import {Observer} from "mobx-react";
import {Button, Dialog, DialogActions, DialogTitle} from "@mui/material";
import {useContext} from "react";
import {AppContext} from "../../stores/AppStore";
import {D} from "../../Constants";

export const ConfirmationDialog = () => {
  const app = useContext(AppContext);

  if (!app) {
    return null;
  }

  return (
    <Observer>
      {() => (
        <Dialog
          open={!!app.confirmationDialogAction}
          onClose={() => app.confirmationDialogAction = undefined}
          slotProps={{
            paper: {
              style: {
                borderRadius: D.radius(2),
              }
            }
          }}
        >
          <DialogTitle variant={'h4'}>
            {app.confirmationDialogText}
          </DialogTitle>
          {app.confirmationDialogContent}
          <DialogActions style={{justifyContent: 'center', padding: '16px 24px'}}>
            <Button
              onClick={() => app.confirmationDialogAction = undefined}
              variant="outlined"
              size="small"
            >
              No
            </Button>
            <Button
              onClick={() => {
                if (app.confirmationDialogAction) {
                  app.confirmationDialogAction();
                  app.confirmationDialogAction = undefined;
                }
              }}
              variant="contained"
              color="primary"
              size="small"
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Observer>
  );
};
